module.exports = __webpack_public_path__ + "img/uin-tip-image.8e92265.svg";